import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { clear as _clear, drawParticle as _drawParticle, drawParticlePlugin as _drawParticlePlugin, drawPlugin as _drawPlugin, paintBase, paintImage } from "../Utils/CanvasUtils";
import { deepExtend, getLogger, safeMutationObserver } from "../Utils/Utils";
import { getStyleFromHsl, getStyleFromRgb, rangeColorToHsl, rangeColorToRgb } from "../Utils/ColorUtils";
import { generatedAttribute } from "./Utils/Constants";

function setTransformValue(factor, newFactor, key) {
  var newValue = newFactor[key];

  if (newValue !== undefined) {
    var _factor$key;

    factor[key] = ((_factor$key = factor[key]) !== null && _factor$key !== void 0 ? _factor$key : 1) * newValue;
  }
}

export var Canvas = /*#__PURE__*/function () {
  function Canvas(container) {
    var _this = this;

    _classCallCheck(this, Canvas);

    this.container = container;

    this._applyPostDrawUpdaters = function (particle) {
      var _iterator = _createForOfIteratorHelper(_this._postDrawUpdaters),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var updater = _step.value;
          updater.afterDraw && updater.afterDraw(particle);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    this._applyPreDrawUpdaters = function (ctx, particle, radius, zOpacity, colorStyles, transform) {
      var _iterator2 = _createForOfIteratorHelper(_this._preDrawUpdaters),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var updater = _step2.value;

          if (updater.getColorStyles) {
            var _updater$getColorStyl = updater.getColorStyles(particle, ctx, radius, zOpacity),
                fill = _updater$getColorStyl.fill,
                stroke = _updater$getColorStyl.stroke;

            if (fill) {
              colorStyles.fill = fill;
            }

            if (stroke) {
              colorStyles.stroke = stroke;
            }
          }

          if (updater.getTransformValues) {
            var updaterTransform = updater.getTransformValues(particle);

            for (var key in updaterTransform) {
              setTransformValue(transform, updaterTransform, key);
            }
          }

          updater.beforeDraw && updater.beforeDraw(particle);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };

    this._applyResizePlugins = function () {
      var _iterator3 = _createForOfIteratorHelper(_this._resizePlugins),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var plugin = _step3.value;
          plugin.resize && plugin.resize();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    };

    this._getPluginParticleColors = function (particle) {
      var fColor, sColor;

      var _iterator4 = _createForOfIteratorHelper(_this._colorPlugins),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var plugin = _step4.value;

          if (!fColor && plugin.particleFillColor) {
            fColor = rangeColorToHsl(plugin.particleFillColor(particle));
          }

          if (!sColor && plugin.particleStrokeColor) {
            sColor = rangeColorToHsl(plugin.particleStrokeColor(particle));
          }

          if (fColor && sColor) {
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return [fColor, sColor];
    };

    this._initCover = function () {
      var options = _this.container.actualOptions,
          cover = options.backgroundMask.cover,
          color = cover.color,
          coverRgb = rangeColorToRgb(color);

      if (coverRgb) {
        var coverColor = _objectSpread(_objectSpread({}, coverRgb), {}, {
          a: cover.opacity
        });

        _this._coverColorStyle = getStyleFromRgb(coverColor, coverColor.a);
      }
    };

    this._initStyle = function () {
      var element = _this.element,
          options = _this.container.actualOptions;

      if (!element) {
        return;
      }

      if (_this._fullScreen) {
        _this._originalStyle = deepExtend({}, element.style);

        _this._setFullScreenStyle();
      } else {
        _this._resetOriginalStyle();
      }

      for (var key in options.style) {
        if (!key || !options.style) {
          continue;
        }

        var value = options.style[key];

        if (!value) {
          continue;
        }

        element.style.setProperty(key, value, "important");
      }
    };

    this._initTrail = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options, trail, trailFill, fillColor, _trail;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _this.container.actualOptions, trail = options.particles.move.trail, trailFill = trail.fill;

              if (trail.enable) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (!trailFill.color) {
                _context.next = 11;
                break;
              }

              fillColor = rangeColorToRgb(trailFill.color);

              if (fillColor) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              _trail = options.particles.move.trail;
              _this._trailFill = {
                color: _objectSpread({}, fillColor),
                opacity: 1 / _trail.length
              };
              _context.next = 13;
              break;

            case 11:
              _context.next = 13;
              return new Promise(function (resolve, reject) {
                if (!trailFill.image) {
                  return;
                }

                var img = document.createElement("img");
                img.addEventListener("load", function () {
                  _this._trailFill = {
                    image: img,
                    opacity: 1 / trail.length
                  };
                  resolve();
                });
                img.addEventListener("error", function (evt) {
                  reject(evt.error);
                });
                img.src = trailFill.image;
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    this._paintBase = function (baseColor) {
      _this.draw(function (ctx) {
        return paintBase(ctx, _this.size, baseColor);
      });
    };

    this._paintImage = function (image, opacity) {
      _this.draw(function (ctx) {
        return paintImage(ctx, _this.size, image, opacity);
      });
    };

    this._repairStyle = function () {
      var element = _this.element;

      if (!element) {
        return;
      }

      _this._safeMutationObserver(function (observer) {
        return observer.disconnect();
      });

      _this._initStyle();

      _this.initBackground();

      _this._safeMutationObserver(function (observer) {
        return observer.observe(element, {
          attributes: true
        });
      });
    };

    this._resetOriginalStyle = function () {
      var element = _this.element,
          originalStyle = _this._originalStyle;

      if (!(element && originalStyle)) {
        return;
      }

      var style = element.style;
      style.position = originalStyle.position;
      style.zIndex = originalStyle.zIndex;
      style.top = originalStyle.top;
      style.left = originalStyle.left;
      style.width = originalStyle.width;
      style.height = originalStyle.height;
    };

    this._safeMutationObserver = function (callback) {
      if (!_this._mutationObserver) {
        return;
      }

      callback(_this._mutationObserver);
    };

    this._setFullScreenStyle = function () {
      var element = _this.element;

      if (!element) {
        return;
      }

      var priority = "important",
          style = element.style;
      style.setProperty("position", "fixed", priority);
      style.setProperty("z-index", _this.container.actualOptions.fullScreen.zIndex.toString(10), priority);
      style.setProperty("top", "0", priority);
      style.setProperty("left", "0", priority);
      style.setProperty("width", "100%", priority);
      style.setProperty("height", "100%", priority);
    };

    this.size = {
      height: 0,
      width: 0
    };
    this._context = null;
    this._generated = false;
    this._preDrawUpdaters = [];
    this._postDrawUpdaters = [];
    this._resizePlugins = [];
    this._colorPlugins = [];
    this._mutationObserver = safeMutationObserver(function (records) {
      var _iterator5 = _createForOfIteratorHelper(records),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var record = _step5.value;

          if (record.type === "attributes" && record.attributeName === "style") {
            _this._repairStyle();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    });
  }

  _createClass(Canvas, [{
    key: "_fullScreen",
    get: function get() {
      return this.container.actualOptions.fullScreen.enable;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      var options = this.container.actualOptions,
          trail = options.particles.move.trail,
          trailFill = this._trailFill;

      if (options.backgroundMask.enable) {
        this.paint();
      } else if (trail.enable && trail.length > 0 && trailFill) {
        if (trailFill.color) {
          this._paintBase(getStyleFromRgb(trailFill.color, trailFill.opacity));
        } else if (trailFill.image) {
          this._paintImage(trailFill.image, trailFill.opacity);
        }
      } else {
        this.draw(function (ctx) {
          _clear(ctx, _this2.size);
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._safeMutationObserver(function (obs) {
        return obs.disconnect();
      });

      if (this._generated) {
        var element = this.element;
        element && element.remove();
      } else {
        this._resetOriginalStyle();
      }

      this.stop();
      this._preDrawUpdaters = [];
      this._postDrawUpdaters = [];
      this._resizePlugins = [];
      this._colorPlugins = [];
    }
  }, {
    key: "draw",
    value: function draw(cb) {
      var ctx = this._context;

      if (!ctx) {
        return;
      }

      return cb(ctx);
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(particle, delta) {
      var _particle$getStrokeCo,
          _this3 = this;

      if (particle.spawning || particle.destroyed) {
        return;
      }

      var radius = particle.getRadius();

      if (radius <= 0) {
        return;
      }

      var pfColor = particle.getFillColor(),
          psColor = (_particle$getStrokeCo = particle.getStrokeColor()) !== null && _particle$getStrokeCo !== void 0 ? _particle$getStrokeCo : pfColor;

      var _this$_getPluginParti = this._getPluginParticleColors(particle),
          _this$_getPluginParti2 = _slicedToArray(_this$_getPluginParti, 2),
          fColor = _this$_getPluginParti2[0],
          sColor = _this$_getPluginParti2[1];

      if (!fColor) {
        fColor = pfColor;
      }

      if (!sColor) {
        sColor = psColor;
      }

      if (!fColor && !sColor) {
        return;
      }

      this.draw(function (ctx) {
        var _ref2, _particle$bubble$opac, _particle$opacity, _particle$strokeOpaci;

        var container = _this3.container,
            options = container.actualOptions,
            zIndexOptions = particle.options.zIndex,
            zOpacityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.opacityRate),
            opacity = (_ref2 = (_particle$bubble$opac = particle.bubble.opacity) !== null && _particle$bubble$opac !== void 0 ? _particle$bubble$opac : (_particle$opacity = particle.opacity) === null || _particle$opacity === void 0 ? void 0 : _particle$opacity.value) !== null && _ref2 !== void 0 ? _ref2 : 1,
            strokeOpacity = (_particle$strokeOpaci = particle.strokeOpacity) !== null && _particle$strokeOpaci !== void 0 ? _particle$strokeOpaci : opacity,
            zOpacity = opacity * zOpacityFactor,
            zStrokeOpacity = strokeOpacity * zOpacityFactor,
            transform = {},
            colorStyles = {
          fill: fColor ? getStyleFromHsl(fColor, zOpacity) : undefined
        };
        colorStyles.stroke = sColor ? getStyleFromHsl(sColor, zStrokeOpacity) : colorStyles.fill;

        _this3._applyPreDrawUpdaters(ctx, particle, radius, zOpacity, colorStyles, transform);

        _drawParticle({
          container: container,
          context: ctx,
          particle: particle,
          delta: delta,
          colorStyles: colorStyles,
          backgroundMask: options.backgroundMask.enable,
          composite: options.backgroundMask.composite,
          radius: radius * Math.pow(1 - particle.zIndexFactor, zIndexOptions.sizeRate),
          opacity: zOpacity,
          shadow: particle.options.shadow,
          transform: transform
        });

        _this3._applyPostDrawUpdaters(particle);
      });
    }
  }, {
    key: "drawParticlePlugin",
    value: function drawParticlePlugin(plugin, particle, delta) {
      this.draw(function (ctx) {
        return _drawParticlePlugin(ctx, plugin, particle, delta);
      });
    }
  }, {
    key: "drawPlugin",
    value: function drawPlugin(plugin, delta) {
      this.draw(function (ctx) {
        return _drawPlugin(ctx, plugin, delta);
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.resize();

                this._initStyle();

                this._initCover();

                _context2.prev = 3;
                _context2.next = 6;
                return this._initTrail();

              case 6:
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);
                getLogger().error(_context2.t0);

              case 11:
                this.initBackground();

                this._safeMutationObserver(function (obs) {
                  if (!_this4.element) {
                    return;
                  }

                  obs.observe(_this4.element, {
                    attributes: true
                  });
                });

                this.initUpdaters();
                this.initPlugins();
                this.paint();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "initBackground",
    value: function initBackground() {
      var options = this.container.actualOptions,
          background = options.background,
          element = this.element;

      if (!element) {
        return;
      }

      var elementStyle = element.style;

      if (!elementStyle) {
        return;
      }

      if (background.color) {
        var color = rangeColorToRgb(background.color);
        elementStyle.backgroundColor = color ? getStyleFromRgb(color, background.opacity) : "";
      } else {
        elementStyle.backgroundColor = "";
      }

      elementStyle.backgroundImage = background.image || "";
      elementStyle.backgroundPosition = background.position || "";
      elementStyle.backgroundRepeat = background.repeat || "";
      elementStyle.backgroundSize = background.size || "";
    }
  }, {
    key: "initPlugins",
    value: function initPlugins() {
      this._resizePlugins = [];

      var _iterator6 = _createForOfIteratorHelper(this.container.plugins),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              plugin = _step6$value[1];

          if (plugin.resize) {
            this._resizePlugins.push(plugin);
          }

          if (plugin.particleFillColor || plugin.particleStrokeColor) {
            this._colorPlugins.push(plugin);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "initUpdaters",
    value: function initUpdaters() {
      this._preDrawUpdaters = [];
      this._postDrawUpdaters = [];

      var _iterator7 = _createForOfIteratorHelper(this.container.particles.updaters),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var updater = _step7.value;

          if (updater.afterDraw) {
            this._postDrawUpdaters.push(updater);
          }

          if (updater.getColorStyles || updater.getTransformValues || updater.beforeDraw) {
            this._preDrawUpdaters.push(updater);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "loadCanvas",
    value: function loadCanvas(canvas) {
      var _this5 = this;

      if (this._generated && this.element) {
        this.element.remove();
      }

      this._generated = canvas.dataset && generatedAttribute in canvas.dataset ? canvas.dataset[generatedAttribute] === "true" : this._generated;
      this.element = canvas;
      this.element.ariaHidden = "true";
      this._originalStyle = deepExtend({}, this.element.style);
      this.size.height = canvas.offsetHeight;
      this.size.width = canvas.offsetWidth;
      this._context = this.element.getContext("2d");

      this._safeMutationObserver(function (obs) {
        if (!_this5.element) {
          return;
        }

        obs.observe(_this5.element, {
          attributes: true
        });
      });

      this.container.retina.init();
      this.initBackground();
    }
  }, {
    key: "paint",
    value: function paint() {
      var _this6 = this;

      var options = this.container.actualOptions;
      this.draw(function (ctx) {
        if (options.backgroundMask.enable && options.backgroundMask.cover) {
          _clear(ctx, _this6.size);

          _this6._paintBase(_this6._coverColorStyle);
        } else {
          _this6._paintBase();
        }
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.element) {
        return false;
      }

      var container = this.container,
          pxRatio = container.retina.pixelRatio,
          size = container.canvas.size,
          newSize = {
        width: this.element.offsetWidth * pxRatio,
        height: this.element.offsetHeight * pxRatio
      };

      if (newSize.height === size.height && newSize.width === size.width && newSize.height === this.element.height && newSize.width === this.element.width) {
        return false;
      }

      var oldSize = _objectSpread({}, size);

      this.element.width = size.width = this.element.offsetWidth * pxRatio;
      this.element.height = size.height = this.element.offsetHeight * pxRatio;

      if (this.container.started) {
        this.resizeFactor = {
          width: size.width / oldSize.width,
          height: size.height / oldSize.height
        };
      }

      return true;
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this7 = this;

      this.draw(function (ctx) {
        return _clear(ctx, _this7.size);
      });
    }
  }, {
    key: "windowResize",
    value: function () {
      var _windowResize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var container, needsRefresh;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this.element || !this.resize())) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                container = this.container, needsRefresh = container.updateActualOptions();
                container.particles.setDensity();

                this._applyResizePlugins();

                if (!needsRefresh) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 8;
                return container.refresh();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function windowResize() {
        return _windowResize.apply(this, arguments);
      }

      return windowResize;
    }()
  }]);

  return Canvas;
}();